webpackJsonp([8],{

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_notification__ = __webpack_require__(1147);




var makeMapStateToProps = function makeMapStateToProps() {
  var getNotification = Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["d" /* makeGetNotification */])();

  var mapStateToProps = function mapStateToProps(state, props) {
    return {
      notification: getNotification(state, props.notification, props.accountId)
    };
  };

  return mapStateToProps;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__components_notification__["a" /* default */]));

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Notification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_status_container__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_account_container__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_permalink__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_immutable_pure_component__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_immutable_pure_component__);





var _class, _temp;










var Notification = (_temp = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Notification, _ImmutablePureCompone);

  function Notification() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.apply(this, arguments));
  }

  Notification.prototype.renderFollow = function renderFollow(account, link) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification notification-follow'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification__message'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification__favourite-icon-wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-user-plus'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_intl__["b" /* FormattedMessage */], {
      id: 'notification.follow',
      defaultMessage: '{name} followed you',
      values: { name: link }
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__containers_account_container__["a" /* default */], {
      id: account.get('id'),
      withNote: false,
      hidden: this.props.hidden
    }));
  };

  Notification.prototype.renderMention = function renderMention(notification) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__containers_status_container__["a" /* default */], {
      id: notification.get('status'),
      withDismiss: true,
      hidden: this.props.hidden
    });
  };

  Notification.prototype.renderFavourite = function renderFavourite(notification, link) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification notification-favourite'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification__message'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification__favourite-icon-wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-star star-icon'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_intl__["b" /* FormattedMessage */], {
      id: 'notification.favourite',
      defaultMessage: '{name} favourited your status',
      values: { name: link }
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__containers_status_container__["a" /* default */], {
      id: notification.get('status'),
      account: notification.get('account'),
      muted: true,
      withDismiss: true,
      hidden: !!this.props.hidden
    }));
  };

  Notification.prototype.renderReblog = function renderReblog(notification, link) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification notification-reblog'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification__message'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'notification__favourite-icon-wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-retweet'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9_react_intl__["b" /* FormattedMessage */], {
      id: 'notification.reblog',
      defaultMessage: '{name} boosted your status',
      values: { name: link }
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__containers_status_container__["a" /* default */], {
      id: notification.get('status'),
      account: notification.get('account'),
      muted: true,
      withDismiss: true,
      hidden: this.props.hidden
    }));
  };

  Notification.prototype.render = function render() {
    var notification = this.props.notification;

    var account = notification.get('account');
    var displayNameHtml = { __html: account.get('display_name_html') };
    var link = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__components_permalink__["a" /* default */], {
      className: 'notification__display-name',
      href: account.get('url'),
      title: account.get('acct'),
      to: '/accounts/' + account.get('id'),
      dangerouslySetInnerHTML: displayNameHtml
    });

    switch (notification.get('type')) {
      case 'follow':
        return this.renderFollow(account, link);
      case 'mention':
        return this.renderMention(notification);
      case 'favourite':
        return this.renderFavourite(notification, link);
      case 'reblog':
        return this.renderReblog(notification, link);
    }

    return null;
  };

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_11_react_immutable_pure_component___default.a), _class.propTypes = {
  notification: __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default.a.map.isRequired,
  hidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
}, _temp);


/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_column_settings__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_settings__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_notifications__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_push_notifications__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_modal__ = __webpack_require__(41);








var messages = Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* defineMessages */])({
  clearMessage: {
    'id': 'notifications.clear_confirmation',
    'defaultMessage': 'Are you sure you want to permanently clear all your notifications?'
  },
  clearConfirm: {
    'id': 'notifications.clear',
    'defaultMessage': 'Clear notifications'
  }
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    settings: state.getIn(['settings', 'notifications']),
    pushSettings: state.get('push_notifications')
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var intl = _ref.intl;
  return {
    onChange: function onChange(key, checked) {
      if (key[0] === 'push') {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_push_notifications__["e" /* changeAlerts */])(key.slice(1), checked));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_settings__["b" /* changeSetting */])(['notifications'].concat(key), checked));
      }
    },
    onSave: function onSave() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions_settings__["c" /* saveSettings */])());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_push_notifications__["g" /* saveSettings */])());
    },
    onClear: function onClear() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_modal__["d" /* openModal */])('CONFIRM', {
        message: intl.formatMessage(messages.clearMessage),
        confirm: intl.formatMessage(messages.clearConfirm),
        onConfirm: function onConfirm() {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_notifications__["j" /* clearNotifications */])());
        }
      }));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["h" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_column_settings__["a" /* default */])));

/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clear_column_button__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setting_toggle__ = __webpack_require__(909);










var ColumnSettings = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ColumnSettings, _React$PureComponent);

  function ColumnSettings() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onPushChange = function (key, checked) {
      _this.props.onChange(['push'].concat(key), checked);
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ColumnSettings.prototype.render = function render() {
    var _props = this.props,
        settings = _props.settings,
        pushSettings = _props.pushSettings,
        onChange = _props.onChange,
        onClear = _props.onClear;


    var alertStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.alert',
      defaultMessage: 'Desktop notifications'
    });
    var showStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.show',
      defaultMessage: 'Show in column'
    });
    var soundStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.sound',
      defaultMessage: 'Play sound'
    });

    var showPushSettings = pushSettings.get('browserSupport') && pushSettings.get('isSubscribed');
    var pushStr = showPushSettings && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.push',
      defaultMessage: 'Push notifications'
    });
    var pushMeta = showPushSettings && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.push_meta',
      defaultMessage: 'This device'
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-settings__row'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__clear_column_button__["a" /* default */], {
      onClick: onClear
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      role: 'group',
      'aria-labelledby': 'notifications-follow'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      id: 'notifications-follow',
      className: 'column-settings__section'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.follow',
      defaultMessage: 'New followers:'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-settings__row'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_desktop',
      settings: settings,
      settingKey: ['alerts', 'follow'],
      onChange: onChange,
      label: alertStr
    }), showPushSettings && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_push',
      settings: pushSettings,
      settingKey: ['alerts', 'follow'],
      meta: pushMeta,
      onChange: this.onPushChange,
      label: pushStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['shows', 'follow'],
      onChange: onChange,
      label: showStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['sounds', 'follow'],
      onChange: onChange,
      label: soundStr
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      role: 'group',
      'aria-labelledby': 'notifications-favourite'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      id: 'notifications-favourite',
      className: 'column-settings__section'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.favourite',
      defaultMessage: 'Favourites:'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-settings__row'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_desktop',
      settings: settings,
      settingKey: ['alerts', 'favourite'],
      onChange: onChange,
      label: alertStr
    }), showPushSettings && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_push',
      settings: pushSettings,
      settingKey: ['alerts', 'favourite'],
      meta: pushMeta,
      onChange: this.onPushChange,
      label: pushStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['shows', 'favourite'],
      onChange: onChange,
      label: showStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['sounds', 'favourite'],
      onChange: onChange,
      label: soundStr
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      role: 'group',
      'aria-labelledby': 'notifications-mention'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      id: 'notifications-mention',
      className: 'column-settings__section'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.mention',
      defaultMessage: 'Mentions:'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-settings__row'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_desktop',
      settings: settings,
      settingKey: ['alerts', 'mention'],
      onChange: onChange,
      label: alertStr
    }), showPushSettings && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_push',
      settings: pushSettings,
      settingKey: ['alerts', 'mention'],
      meta: pushMeta,
      onChange: this.onPushChange,
      label: pushStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['shows', 'mention'],
      onChange: onChange,
      label: showStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['sounds', 'mention'],
      onChange: onChange,
      label: soundStr
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      role: 'group',
      'aria-labelledby': 'notifications-reblog'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      id: 'notifications-reblog',
      className: 'column-settings__section'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.column_settings.reblog',
      defaultMessage: 'Boosts:'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-settings__row'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_desktop',
      settings: settings,
      settingKey: ['alerts', 'reblog'],
      onChange: onChange,
      label: alertStr
    }), showPushSettings && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications_push',
      settings: pushSettings,
      settingKey: ['alerts', 'reblog'],
      meta: pushMeta,
      onChange: this.onPushChange,
      label: pushStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['shows', 'reblog'],
      onChange: onChange,
      label: showStr
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__setting_toggle__["a" /* default */], {
      prefix: 'notifications',
      settings: settings,
      settingKey: ['sounds', 'reblog'],
      onChange: onChange,
      label: soundStr
    }))));
  };

  return ColumnSettings;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);



/***/ }),

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClearColumnButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);








var ClearColumnButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ClearColumnButton, _React$Component);

  function ClearColumnButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ClearColumnButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ClearColumnButton.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      className: 'text-btn column-header__setting-btn',
      tabIndex: '0',
      onClick: this.props.onClick
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-eraser'
    }), ' ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'notifications.clear',
      defaultMessage: 'Clear notifications'
    }));
  };

  return ClearColumnButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);



/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ScrollContext = exports.ScrollContainer = undefined;

var _ScrollContainer2 = __webpack_require__(302);

var _ScrollContainer3 = _interopRequireDefault(_ScrollContainer2);

var _ScrollBehaviorContext = __webpack_require__(175);

var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ScrollContainer = _ScrollContainer3.default;
exports.ScrollContext = _ScrollBehaviorContext2.default;

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(44);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(29);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  scrollKey: _react2.default.PropTypes.string.isRequired,
  shouldUpdateScroll: _react2.default.PropTypes.func,
  children: _react2.default.PropTypes.element.isRequired
};

var contextTypes = {
  // This is necessary when rendering on the client. However, when rendering on
  // the server, this container will do nothing, and thus does not require the
  // scroll behavior context.
  scrollBehavior: _react2.default.PropTypes.object
};

var ScrollContainer = function (_React$Component) {
  _inherits(ScrollContainer, _React$Component);

  function ScrollContainer(props, context) {
    _classCallCheck(this, ScrollContainer);

    // We don't re-register if the scroll key changes, so make sure we
    // unregister with the initial scroll key just in case the user changes it.
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
      var shouldUpdateScroll = _this.props.shouldUpdateScroll;

      if (!shouldUpdateScroll) {
        return true;
      }

      // Hack to allow accessing scrollBehavior._stateStorage.
      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
    };

    _this.scrollKey = props.scrollKey;
    return _this;
  }

  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
    this.shouldUpdateScroll);

    // Only keep around the current DOM node in development, as this is only
    // for emitting the appropriate warning.
    if (false) {
      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    }
  };

  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, '<ScrollContainer> does not support changing scrollKey.') : void 0;
  };

  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
    if (false) {
      var prevDomNode = this.domNode;
      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

      process.env.NODE_ENV !== 'production' ? (0, _warning2.default)(this.domNode === prevDomNode, '<ScrollContainer> does not support changing DOM node.') : void 0;
    }
  };

  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.context.scrollBehavior.unregisterElement(this.scrollKey);
  };

  ScrollContainer.prototype.render = function render() {
    return this.props.children;
  };

  return ScrollContainer;
}(_react2.default.Component);

ScrollContainer.propTypes = propTypes;
ScrollContainer.contextTypes = contextTypes;

exports.default = ScrollContainer;
module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadMore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);





var _class, _temp;



var LoadMore = (_temp = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LoadMore, _React$PureComponent);

  function LoadMore() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LoadMore);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.apply(this, arguments));
  }

  LoadMore.prototype.render = function render() {
    var visible = this.props.visible;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      className: 'load-more',
      disabled: !visible,
      style: { visibility: visible ? 'visible' : 'hidden' },
      onClick: this.props.onClick
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'status.load_more',
      defaultMessage: 'Load more'
    }));
  };

  return LoadMore;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.defaultProps = {
  visible: true
}, _temp);


/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_status__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_compose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_interactions__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_accounts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_statuses__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_reports__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_modal__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);













var messages = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["g" /* defineMessages */])({
  deleteConfirm: {
    'id': 'confirmations.delete.confirm',
    'defaultMessage': 'Delete'
  },
  deleteMessage: {
    'id': 'confirmations.delete.message',
    'defaultMessage': 'Are you sure you want to delete this status?'
  },
  blockConfirm: {
    'id': 'confirmations.block.confirm',
    'defaultMessage': 'Block'
  },
  muteConfirm: {
    'id': 'confirmations.mute.confirm',
    'defaultMessage': 'Mute'
  }
});

var makeMapStateToProps = function makeMapStateToProps() {
  var getStatus = Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["e" /* makeGetStatus */])();

  var mapStateToProps = function mapStateToProps(state, props) {
    return {
      status: getStatus(state, props.id),
      me: state.getIn(['meta', 'me']),
      boostModal: state.getIn(['meta', 'boost_modal']),
      deleteModal: state.getIn(['meta', 'delete_modal']),
      autoPlayGif: state.getIn(['meta', 'auto_play_gif'])
    };
  };

  return mapStateToProps;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var intl = _ref.intl;
  return {
    onReply: function onReply(status, router) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_compose__["J" /* replyCompose */])(status, router));
    },
    onModalReblog: function onModalReblog(status) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["q" /* reblog */])(status));
    },
    onReblog: function onReblog(status, e) {
      if (status.get('reblogged')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["t" /* unreblog */])(status));
      } else {
        if (e.shiftKey || !this.boostModal) {
          this.onModalReblog(status);
        } else {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('BOOST', { status: status, onReblog: this.onModalReblog }));
        }
      }
    },
    onFavourite: function onFavourite(status) {
      if (status.get('favourited')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["r" /* unfavourite */])(status));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["m" /* favourite */])(status));
      }
    },
    onPin: function onPin(status) {
      if (status.get('pinned')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["s" /* unpin */])(status));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_interactions__["p" /* pin */])(status));
      }
    },
    onEmbed: function onEmbed(status) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('EMBED', { url: status.get('url') }));
    },
    onDelete: function onDelete(status) {
      if (!this.deleteModal) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["e" /* deleteStatus */])(status.get('id')));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('CONFIRM', {
          message: intl.formatMessage(messages.deleteMessage),
          confirm: intl.formatMessage(messages.deleteConfirm),
          onConfirm: function onConfirm() {
            return dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["e" /* deleteStatus */])(status.get('id')));
          }
        }));
      }
    },
    onMention: function onMention(account, router) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions_compose__["H" /* mentionCompose */])(account, router));
    },
    onOpenMedia: function onOpenMedia(media, index) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('MEDIA', { media: media, index: index }));
    },
    onOpenVideo: function onOpenVideo(media, time) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('VIDEO', { media: media, time: time }));
    },
    onBlock: function onBlock(account) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('CONFIRM', {
        message: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_intl__["b" /* FormattedMessage */], {
          id: 'confirmations.block.message',
          defaultMessage: 'Are you sure you want to block {name}?',
          values: { name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('strong', {}, void 0, '@', account.get('acct')) }
        }),
        confirm: intl.formatMessage(messages.blockConfirm),
        onConfirm: function onConfirm() {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_accounts__["r" /* blockAccount */])(account.get('id')));
        }
      }));
    },
    onReport: function onReport(status) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_reports__["i" /* initReport */])(status.get('account'), status));
    },
    onMute: function onMute(account) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_modal__["d" /* openModal */])('CONFIRM', {
        message: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11_react_intl__["b" /* FormattedMessage */], {
          id: 'confirmations.mute.message',
          defaultMessage: 'Are you sure you want to mute {name}?',
          values: { name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('strong', {}, void 0, '@', account.get('acct')) }
        }),
        confirm: intl.formatMessage(messages.muteConfirm),
        onConfirm: function onConfirm() {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_accounts__["B" /* muteAccount */])(account.get('id')));
        }
      }));
    },
    onMuteConversation: function onMuteConversation(status) {
      if (status.get('muted')) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["i" /* unmuteStatus */])(status.get('id')));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["g" /* muteStatus */])(status.get('id')));
      }
    },
    onHeightChange: function onHeightChange(status, height) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__actions_statuses__["h" /* setStatusHeight */])(status.get('id'), height));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["h" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_status__["a" /* default */])));

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_scroll__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_router_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_intersection_observer_article_container__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__load_more__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__features_ui_util_intersection_observer_wrapper__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_immutable__);






var _class, _temp2;










var ScrollableList = (_temp2 = _class = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ScrollableList, _PureComponent);

  function ScrollableList() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollableList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.state = {
      lastMouseMove: null
    }, _this.intersectionObserverWrapper = new __WEBPACK_IMPORTED_MODULE_10__features_ui_util_intersection_observer_wrapper__["a" /* default */](), _this.handleScroll = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function () {
      if (_this.node) {
        var _this$node = _this.node,
            scrollTop = _this$node.scrollTop,
            scrollHeight = _this$node.scrollHeight,
            clientHeight = _this$node.clientHeight;

        var offset = scrollHeight - scrollTop - clientHeight;
        _this._oldScrollPosition = scrollHeight - scrollTop;

        if (400 > offset && _this.props.onScrollToBottom && !_this.props.isLoading) {
          _this.props.onScrollToBottom();
        } else if (scrollTop < 100 && _this.props.onScrollToTop) {
          _this.props.onScrollToTop();
        } else if (_this.props.onScroll) {
          _this.props.onScroll();
        }
      }
    }, 150, {
      trailing: true
    }), _this.handleMouseMove = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function () {
      _this._lastMouseMove = new Date();
    }, 300), _this.handleMouseLeave = function () {
      _this._lastMouseMove = null;
    }, _this.setRef = function (c) {
      _this.node = c;
    }, _this.handleLoadMore = function (e) {
      e.preventDefault();
      _this.props.onScrollToBottom();
    }, _this.handleKeyDown = function (e) {
      if (['PageDown', 'PageUp'].includes(e.key) || e.ctrlKey && ['End', 'Home'].includes(e.key)) {
        var article = function () {
          switch (e.key) {
            case 'PageDown':
              return e.target.nodeName === 'ARTICLE' && e.target.nextElementSibling;
            case 'PageUp':
              return e.target.nodeName === 'ARTICLE' && e.target.previousElementSibling;
            case 'End':
              return _this.node.querySelector('[role="feed"] > article:last-of-type');
            case 'Home':
              return _this.node.querySelector('[role="feed"] > article:first-of-type');
            default:
              return null;
          }
        }();

        if (article) {
          e.preventDefault();
          article.focus();
          article.scrollIntoView();
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ScrollableList.prototype.componentDidMount = function componentDidMount() {
    this.attachScrollListener();
    this.attachIntersectionObserver();

    // Handle initial scroll posiiton
    this.handleScroll();
  };

  ScrollableList.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var someItemInserted = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(prevProps.children) > 0 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(prevProps.children) < __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children) && this.getFirstChildKey(prevProps) !== this.getFirstChildKey(this.props);

    // Reset the scroll position when a new child comes in in order not to
    // jerk the scrollbar around if you're already scrolled down the page.
    if (someItemInserted && this._oldScrollPosition && this.node.scrollTop > 0) {
      var newScrollTop = this.node.scrollHeight - this._oldScrollPosition;

      if (this.node.scrollTop !== newScrollTop) {
        this.node.scrollTop = newScrollTop;
      }
    } else {
      this._oldScrollPosition = this.node.scrollHeight - this.node.scrollTop;
    }
  };

  ScrollableList.prototype.componentWillUnmount = function componentWillUnmount() {
    this.detachScrollListener();
    this.detachIntersectionObserver();
  };

  ScrollableList.prototype.attachIntersectionObserver = function attachIntersectionObserver() {
    this.intersectionObserverWrapper.connect({
      root: this.node,
      rootMargin: '300% 0px'
    });
  };

  ScrollableList.prototype.detachIntersectionObserver = function detachIntersectionObserver() {
    this.intersectionObserverWrapper.disconnect();
  };

  ScrollableList.prototype.attachScrollListener = function attachScrollListener() {
    this.node.addEventListener('scroll', this.handleScroll);
  };

  ScrollableList.prototype.detachScrollListener = function detachScrollListener() {
    this.node.removeEventListener('scroll', this.handleScroll);
  };

  ScrollableList.prototype.getFirstChildKey = function getFirstChildKey(props) {
    var children = props.children;

    var firstChild = children;
    if (children instanceof __WEBPACK_IMPORTED_MODULE_11_immutable__["List"]) {
      firstChild = children.get(0);
    } else if (Array.isArray(children)) {
      firstChild = children[0];
    }
    return firstChild && firstChild.key;
  };

  ScrollableList.prototype._recentlyMoved = function _recentlyMoved() {
    return this._lastMouseMove !== null && new Date() - this._lastMouseMove < 600;
  };

  ScrollableList.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        scrollKey = _props.scrollKey,
        trackScroll = _props.trackScroll,
        shouldUpdateScroll = _props.shouldUpdateScroll,
        isLoading = _props.isLoading,
        hasMore = _props.hasMore,
        prepend = _props.prepend,
        emptyMessage = _props.emptyMessage;

    var childrenCount = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(children);

    var loadMore = hasMore && childrenCount > 0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__load_more__["a" /* default */], {
      visible: !isLoading,
      onClick: this.handleLoadMore
    }) : null;
    var scrollableArea = null;

    if (isLoading || childrenCount > 0 || !emptyMessage) {
      scrollableArea = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'scrollable', ref: this.setRef, onMouseMove: this.handleMouseMove, onMouseLeave: this.handleMouseLeave },
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
          role: 'feed',
          className: 'item-list',
          onKeyDown: this.handleKeyDown
        }, void 0, prepend, __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(this.props.children, function (child, index) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__containers_intersection_observer_article_container__["a" /* default */], {
            id: child.key,
            index: index,
            listLength: childrenCount,
            intersectionObserverWrapper: _this2.intersectionObserverWrapper,
            saveHeightKey: trackScroll ? _this2.context.router.route.location.key + ':' + scrollKey : null
          }, child.key, child);
        }), loadMore)
      );
    } else {
      scrollableArea = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'empty-column-indicator', ref: this.setRef },
        emptyMessage
      );
    }

    if (trackScroll) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react_router_scroll__["ScrollContainer"], {
        scrollKey: scrollKey,
        shouldUpdateScroll: shouldUpdateScroll
      }, void 0, scrollableArea);
    } else {
      return scrollableArea;
    }
  };

  return ScrollableList;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]), _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
}, _class.defaultProps = {
  trackScroll: true
}, _temp2);


/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_intersection_observer_article__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_height_cache__ = __webpack_require__(113);




var makeMapStateToProps = function makeMapStateToProps(state, props) {
  return {
    cachedHeight: state.getIn(['height_cache', props.saveHeightKey, props.id])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onHeightChange: function onHeightChange(key, id, height) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_height_cache__["d" /* setHeight */])(key, id, height));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_intersection_observer_article__["a" /* default */]));

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IntersectionObserverArticle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__features_ui_util_schedule_idle_task__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__features_ui_util_get_rect_from_entry__ = __webpack_require__(312);




var _class, _temp2;







var IntersectionObserverArticle = (_temp2 = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(IntersectionObserverArticle, _ImmutablePureCompone);

  function IntersectionObserverArticle() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IntersectionObserverArticle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.state = {
      isHidden: false // set to true in requestIdleCallback to trigger un-render
    }, _this.handleIntersection = function (entry) {
      var _this$props = _this.props,
          onHeightChange = _this$props.onHeightChange,
          saveHeightKey = _this$props.saveHeightKey,
          id = _this$props.id;


      if (_this.node && _this.node.children.length !== 0) {
        // save the height of the fully-rendered element
        _this.height = Object(__WEBPACK_IMPORTED_MODULE_7__features_ui_util_get_rect_from_entry__["a" /* default */])(entry).height;

        if (onHeightChange && saveHeightKey) {
          onHeightChange(saveHeightKey, id, _this.height);
        }
      }

      _this.setState(function (prevState) {
        if (prevState.isIntersecting && !entry.isIntersecting) {
          Object(__WEBPACK_IMPORTED_MODULE_6__features_ui_util_schedule_idle_task__["a" /* default */])(_this.hideIfNotIntersecting);
        }
        return {
          isIntersecting: entry.isIntersecting,
          isHidden: false
        };
      });
    }, _this.hideIfNotIntersecting = function () {
      if (!_this.componentMounted) {
        return;
      }

      // When the browser gets a chance, test if we're still not intersecting,
      // and if so, set our isHidden to true to trigger an unrender. The point of
      // this is to save DOM nodes and avoid using up too much memory.
      // See: https://github.com/tootsuite/mastodon/issues/2900
      _this.setState(function (prevState) {
        return { isHidden: !prevState.isIntersecting };
      });
    }, _this.handleRef = function (node) {
      _this.node = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  IntersectionObserverArticle.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (!nextState.isIntersecting && nextState.isHidden) {
      // It's only if we're not intersecting (i.e. offscreen) and isHidden is true
      // that either "isIntersecting" or "isHidden" matter, and then they're
      // the only things that matter (and updated ARIA attributes).
      return this.state.isIntersecting || !this.state.isHidden || nextProps.listLength !== this.props.listLength;
    } else if (nextState.isIntersecting && !this.state.isIntersecting) {
      // If we're going from a non-intersecting state to an intersecting state,
      // (i.e. offscreen to onscreen), then we definitely need to re-render
      return true;
    }
    // Otherwise, diff based on "updateOnProps" and "updateOnStates"
    return _ImmutablePureCompone.prototype.shouldComponentUpdate.call(this, nextProps, nextState);
  };

  IntersectionObserverArticle.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        intersectionObserverWrapper = _props.intersectionObserverWrapper,
        id = _props.id;


    intersectionObserverWrapper.observe(id, this.node, this.handleIntersection);

    this.componentMounted = true;
  };

  IntersectionObserverArticle.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        intersectionObserverWrapper = _props2.intersectionObserverWrapper,
        id = _props2.id;

    intersectionObserverWrapper.unobserve(id, this.node);

    this.componentMounted = false;
  };

  IntersectionObserverArticle.prototype.render = function render() {
    var _props3 = this.props,
        children = _props3.children,
        id = _props3.id,
        index = _props3.index,
        listLength = _props3.listLength,
        cachedHeight = _props3.cachedHeight;
    var _state = this.state,
        isIntersecting = _state.isIntersecting,
        isHidden = _state.isHidden;


    if (!isIntersecting && (isHidden || cachedHeight)) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        'article',
        {
          ref: this.handleRef,
          'aria-posinset': index,
          'aria-setsize': listLength,
          style: { height: (this.height || cachedHeight) + 'px', opacity: 0, overflow: 'hidden' },
          'data-id': id,
          tabIndex: '0'
        },
        children && __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(children, { hidden: true })
      );
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'article',
      { ref: this.handleRef, 'aria-posinset': index, 'aria-setsize': listLength, 'data-id': id, tabIndex: '0' },
      children && __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(children, { hidden: false })
    );
  };

  return IntersectionObserverArticle;
}(__WEBPACK_IMPORTED_MODULE_5_react_immutable_pure_component___default.a), _class.propTypes = {
  intersectionObserverWrapper: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  index: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  listLength: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  saveHeightKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  cachedHeight: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  onHeightChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
}, _temp2);


/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_queue__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tiny_queue__);
// Wrapper to call requestIdleCallback() to schedule low-priority work.
// See https://developer.mozilla.org/en-US/docs/Web/API/Background_Tasks_API
// for a good breakdown of the concepts behind this.



var taskQueue = new __WEBPACK_IMPORTED_MODULE_0_tiny_queue___default.a();
var runningRequestIdleCallback = false;

function runTasks(deadline) {
  while (taskQueue.length && deadline.timeRemaining() > 0) {
    taskQueue.shift()();
  }
  if (taskQueue.length) {
    requestIdleCallback(runTasks);
  } else {
    runningRequestIdleCallback = false;
  }
}

function scheduleIdleTask(task) {
  taskQueue.push(task);
  if (!runningRequestIdleCallback) {
    runningRequestIdleCallback = true;
    requestIdleCallback(runTasks);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (scheduleIdleTask);

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Simple FIFO queue implementation to avoid having to do shift()
// on an array, which is slow.

function Queue() {
  this.length = 0;
}

Queue.prototype.push = function (item) {
  var node = {item: item};
  if (this.last) {
    this.last = this.last.next = node;
  } else {
    this.last = this.first = node;
  }
  this.length++;
};

Queue.prototype.shift = function () {
  var node = this.first;
  if (node) {
    this.first = node.next;
    if (!(--this.length)) {
      this.last = undefined;
    }
    return node.item;
  }
};

Queue.prototype.slice = function (start, end) {
  start = typeof start === 'undefined' ? 0 : start;
  end = typeof end === 'undefined' ? Infinity : end;

  var output = [];

  var i = 0;
  for (var node = this.first; node; node = node.next) {
    if (--end < 0) {
      break;
    } else if (++i > start) {
      output.push(node.item);
    }
  }
  return output;
}

module.exports = Queue;


/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// Get the bounding client rect from an IntersectionObserver entry.
// This is to work around a bug in Chrome: https://crbug.com/737228

var hasBoundingRectBug = void 0;

function getRectFromEntry(entry) {
  if (typeof hasBoundingRectBug !== 'boolean') {
    var boundingRect = entry.target.getBoundingClientRect();
    var observerRect = entry.boundingClientRect;
    hasBoundingRectBug = boundingRect.height !== observerRect.height || boundingRect.top !== observerRect.top || boundingRect.width !== observerRect.width || boundingRect.bottom !== observerRect.bottom || boundingRect.left !== observerRect.left || boundingRect.right !== observerRect.right;
  }
  return hasBoundingRectBug ? entry.target.getBoundingClientRect() : entry.boundingClientRect;
}

/* harmony default export */ __webpack_exports__["a"] = (getRectFromEntry);

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


// Wrapper for IntersectionObserver in order to make working with it
// a bit easier. We also follow this performance advice:
// "If you need to observe multiple elements, it is both possible and
// advised to observe multiple elements using the same IntersectionObserver
// instance by calling observe() multiple times."
// https://developers.google.com/web/updates/2016/04/intersectionobserver

var IntersectionObserverWrapper = function () {
  function IntersectionObserverWrapper() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, IntersectionObserverWrapper);

    this.callbacks = {};
    this.observerBacklog = [];
    this.observer = null;
  }

  IntersectionObserverWrapper.prototype.connect = function connect(options) {
    var _this = this;

    var onIntersection = function onIntersection(entries) {
      entries.forEach(function (entry) {
        var id = entry.target.getAttribute('data-id');
        if (_this.callbacks[id]) {
          _this.callbacks[id](entry);
        }
      });
    };

    this.observer = new IntersectionObserver(onIntersection, options);
    this.observerBacklog.forEach(function (_ref) {
      var id = _ref[0],
          node = _ref[1],
          callback = _ref[2];

      _this.observe(id, node, callback);
    });
    this.observerBacklog = null;
  };

  IntersectionObserverWrapper.prototype.observe = function observe(id, node, callback) {
    if (!this.observer) {
      this.observerBacklog.push([id, node, callback]);
    } else {
      this.callbacks[id] = callback;
      this.observer.observe(node);
    }
  };

  IntersectionObserverWrapper.prototype.unobserve = function unobserve(id, node) {
    if (this.observer) {
      delete this.callbacks[id];
      this.observer.unobserve(node);
    }
  };

  IntersectionObserverWrapper.prototype.disconnect = function disconnect() {
    if (this.observer) {
      this.callbacks = {};
      this.observer.disconnect();
      this.observer = null;
    }
  };

  return IntersectionObserverWrapper;
}();

/* harmony default export */ __webpack_exports__["a"] = (IntersectionObserverWrapper);

/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Notifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_column__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_column_header__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_notifications__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_columns__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_notification_container__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_column_settings_container__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reselect__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_immutable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_scrollable_list__ = __webpack_require__(307);






var _dec, _class, _class2, _temp2;
















var messages = Object(__WEBPACK_IMPORTED_MODULE_12_react_intl__["g" /* defineMessages */])({
  title: {
    'id': 'column.notifications',
    'defaultMessage': 'Notifications'
  }
});

var getNotifications = Object(__WEBPACK_IMPORTED_MODULE_14_reselect__["createSelector"])([function (state) {
  return Object(__WEBPACK_IMPORTED_MODULE_15_immutable__["List"])(state.getIn(['settings', 'notifications', 'shows']).filter(function (item) {
    return !item;
  }).keys());
}, function (state) {
  return state.getIn(['notifications', 'items']);
}], function (excludedTypes, notifications) {
  return notifications.filterNot(function (item) {
    return excludedTypes.includes(item.get('type'));
  });
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    notifications: getNotifications(state),
    isLoading: state.getIn(['notifications', 'isLoading'], true),
    isUnread: state.getIn(['notifications', 'unread']) > 0,
    hasMore: !!state.getIn(['notifications', 'next'])
  };
};

var Notifications = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps), _dec(_class = Object(__WEBPACK_IMPORTED_MODULE_12_react_intl__["h" /* injectIntl */])(_class = (_temp2 = _class2 = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Notifications, _React$PureComponent);

  function Notifications() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notifications);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleScrollToBottom = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_notifications__["m" /* scrollTopNotifications */])(false));
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_notifications__["k" /* expandNotifications */])());
    }, 300, { leading: true }), _this.handleScrollToTop = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_notifications__["m" /* scrollTopNotifications */])(true));
    }, 100), _this.handleScroll = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function () {
      _this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__actions_notifications__["m" /* scrollTopNotifications */])(false));
    }, 100), _this.handlePin = function () {
      var _this$props = _this.props,
          columnId = _this$props.columnId,
          dispatch = _this$props.dispatch;


      if (columnId) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_columns__["f" /* removeColumn */])(columnId));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_columns__["d" /* addColumn */])('NOTIFICATIONS', {}));
      }
    }, _this.handleMove = function (dir) {
      var _this$props2 = _this.props,
          columnId = _this$props2.columnId,
          dispatch = _this$props2.dispatch;

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_columns__["e" /* moveColumn */])(columnId, dir));
    }, _this.handleHeaderClick = function () {
      _this.column.scrollTop();
    }, _this.setColumnRef = function (c) {
      _this.column = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Notifications.prototype.render = function render() {
    var _props = this.props,
        intl = _props.intl,
        notifications = _props.notifications,
        shouldUpdateScroll = _props.shouldUpdateScroll,
        isLoading = _props.isLoading,
        isUnread = _props.isUnread,
        columnId = _props.columnId,
        multiColumn = _props.multiColumn,
        hasMore = _props.hasMore;

    var pinned = !!columnId;
    var emptyMessage = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12_react_intl__["b" /* FormattedMessage */], {
      id: 'empty_column.notifications',
      defaultMessage: 'You don\'t have any notifications yet. Interact with others to start the conversation.'
    });

    var scrollableContent = null;

    if (isLoading && this.scrollableContent) {
      scrollableContent = this.scrollableContent;
    } else if (notifications.size > 0 || hasMore) {
      scrollableContent = notifications.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__containers_notification_container__["a" /* default */], {
          notification: item,
          accountId: item.get('account')
        }, item.get('id'));
      });
    } else {
      scrollableContent = null;
    }

    this.scrollableContent = scrollableContent;

    var scrollContainer = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__components_scrollable_list__["a" /* default */], {
      scrollKey: 'notifications-' + columnId,
      trackScroll: !pinned,
      isLoading: isLoading,
      hasMore: hasMore,
      emptyMessage: emptyMessage,
      onScrollToBottom: this.handleScrollToBottom,
      onScrollToTop: this.handleScrollToTop,
      onScroll: this.handleScroll,
      shouldUpdateScroll: shouldUpdateScroll
    }, void 0, scrollableContent);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__components_column__["a" /* default */],
      { ref: this.setColumnRef },
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__components_column_header__["a" /* default */], {
        icon: 'bell',
        active: isUnread,
        title: intl.formatMessage(messages.title),
        onPin: this.handlePin,
        onMove: this.handleMove,
        onClick: this.handleHeaderClick,
        pinned: pinned,
        multiColumn: multiColumn
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__containers_column_settings_container__["a" /* default */], {})),
      scrollContainer
    );
  };

  return Notifications;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent), _class2.defaultProps = {
  trackScroll: true
}, _temp2)) || _class) || _class);


/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_account__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_accounts__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_modal__ = __webpack_require__(41);









var messages = Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["g" /* defineMessages */])({
  unfollowConfirm: {
    'id': 'confirmations.unfollow.confirm',
    'defaultMessage': 'Unfollow'
  }
});

var makeMapStateToProps = function makeMapStateToProps() {
  var getAccount = Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["c" /* makeGetAccount */])();

  var mapStateToProps = function mapStateToProps(state, props) {
    return {
      account: getAccount(state, props.id),
      me: state.getIn(['meta', 'me']),
      unfollowModal: state.getIn(['meta', 'unfollow_modal'])
    };
  };

  return mapStateToProps;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var intl = _ref.intl;
  return {
    onFollow: function onFollow(account) {
      if (account.getIn(['relationship', 'following']) || account.getIn(['relationship', 'requested'])) {
        if (this.unfollowModal) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__actions_modal__["d" /* openModal */])('CONFIRM', {
            message: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], {
              id: 'confirmations.unfollow.message',
              defaultMessage: 'Are you sure you want to unfollow {name}?',
              values: { name: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('strong', {}, void 0, '@', account.get('acct')) }
            }),
            confirm: intl.formatMessage(messages.unfollowConfirm),
            onConfirm: function onConfirm() {
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_accounts__["E" /* unfollowAccount */])(account.get('id')));
            }
          }));
        } else {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_accounts__["E" /* unfollowAccount */])(account.get('id')));
        }
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_accounts__["A" /* followAccount */])(account.get('id')));
      }
    },
    onBlock: function onBlock(account) {
      if (account.getIn(['relationship', 'blocking'])) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_accounts__["D" /* unblockAccount */])(account.get('id')));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_accounts__["r" /* blockAccount */])(account.get('id')));
      }
    },
    onMute: function onMute(account) {
      if (account.getIn(['relationship', 'muting'])) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_accounts__["F" /* unmuteAccount */])(account.get('id')));
      } else {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__actions_accounts__["B" /* muteAccount */])(account.get('id')));
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["h" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(makeMapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_5__components_account__["a" /* default */])));

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Account; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__avatar__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__display_name__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__permalink__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__icon_button__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component__);





var _class, _class2, _temp2;











var messages = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["g" /* defineMessages */])({
  follow: {
    'id': 'account.follow',
    'defaultMessage': 'Follow'
  },
  unfollow: {
    'id': 'account.unfollow',
    'defaultMessage': 'Unfollow'
  },
  requested: {
    'id': 'account.requested',
    'defaultMessage': 'Awaiting approval'
  },
  unblock: {
    'id': 'account.unblock',
    'defaultMessage': 'Unblock @{name}'
  },
  unmute: {
    'id': 'account.unmute',
    'defaultMessage': 'Unmute @{name}'
  }
});

var Account = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["h" /* injectIntl */])(_class = (_temp2 = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Account, _ImmutablePureCompone);

  function Account() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Account);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.handleFollow = function () {
      _this.props.onFollow(_this.props.account);
    }, _this.handleBlock = function () {
      _this.props.onBlock(_this.props.account);
    }, _this.handleMute = function () {
      _this.props.onMute(_this.props.account);
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Account.prototype.render = function render() {
    var _props = this.props,
        account = _props.account,
        me = _props.me,
        intl = _props.intl,
        hidden = _props.hidden;


    if (!account) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {});
    }

    if (hidden) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, account.get('display_name'), account.get('username'));
    }

    var buttons = void 0;

    if (account.get('id') !== me && account.get('relationship', null) !== null) {
      var following = account.getIn(['relationship', 'following']);
      var requested = account.getIn(['relationship', 'requested']);
      var blocking = account.getIn(['relationship', 'blocking']);
      var muting = account.getIn(['relationship', 'muting']);

      if (requested) {
        buttons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__icon_button__["a" /* default */], {
          disabled: true,
          icon: 'hourglass',
          title: intl.formatMessage(messages.requested)
        });
      } else if (blocking) {
        buttons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__icon_button__["a" /* default */], {
          active: true,
          icon: 'unlock-alt',
          title: intl.formatMessage(messages.unblock, { name: account.get('username') }),
          onClick: this.handleBlock
        });
      } else if (muting) {
        buttons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__icon_button__["a" /* default */], {
          active: true,
          icon: 'volume-up',
          title: intl.formatMessage(messages.unmute, { name: account.get('username') }),
          onClick: this.handleMute
        });
      } else {
        buttons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__icon_button__["a" /* default */], {
          icon: following ? 'user-times' : 'user-plus',
          title: intl.formatMessage(following ? messages.unfollow : messages.follow),
          onClick: this.handleFollow,
          active: following
        });
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__permalink__["a" /* default */], {
      className: 'account__display-name',
      href: account.get('url'),
      to: '/accounts/' + account.get('id')
    }, account.get('id'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__avatar-wrapper'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__avatar__["a" /* default */], {
      account: account,
      size: 36
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__display_name__["a" /* default */], {
      account: account
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__relationship'
    }, void 0, buttons)));
  };

  return Account;
}(__WEBPACK_IMPORTED_MODULE_12_react_immutable_pure_component___default.a), _class2.propTypes = {
  account: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map.isRequired,
  me: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,
  onFollow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  onBlock: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  onMute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired,
  hidden: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
}, _temp2)) || _class;



/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(37);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _check = __webpack_require__(877);

var _check2 = _interopRequireDefault(_check);

var _x = __webpack_require__(878);

var _x2 = _interopRequireDefault(_x);

var _util = __webpack_require__(879);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({ checked: !!nextProps.checked });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      var checkbox = this.input;
      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }

      this.setState({ checked: checkbox.checked });
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      this.startX = (0, _util.pointerCoord)(event).x;
      this.activated = true;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;

      if (this.startX) {
        var currentX = (0, _util.pointerCoord)(event).x;
        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({ checked: false });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({ checked: true });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();

      if (this.startX) {
        var endX = (0, _util.pointerCoord)(event).x;
        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: false });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: true });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }

        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;


      if (onFocus) {
        onFocus(event);
      }

      this.setState({ hasFocus: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;


      if (onBlur) {
        onBlur(event);
      }

      this.setState({ hasFocus: false });
    }
  }, {
    key: 'getIcon',
    value: function getIcon(type) {
      var icons = this.props.icons;

      if (!icons) {
        return null;
      }
      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          _icons = _props.icons,
          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);

      var classes = (0, _classnames2.default)('react-toggle', {
        'react-toggle--checked': this.state.checked,
        'react-toggle--focus': this.state.hasFocus,
        'react-toggle--disabled': this.props.disabled
      }, className);

      return _react2.default.createElement(
        'div',
        { className: classes,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd },
        _react2.default.createElement(
          'div',
          { className: 'react-toggle-track' },
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-check' },
            this.getIcon('checked')
          ),
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-x' },
            this.getIcon('unchecked')
          )
        ),
        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(_ref) {
            _this2.input = _ref;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: 'react-toggle-screenreader-only',
          type: 'checkbox' }))
      );
    }
  }]);

  return Toggle;
}(_react.PureComponent);

exports.default = Toggle;


Toggle.displayName = 'Toggle';

Toggle.defaultProps = {
  icons: {
    checked: _react2.default.createElement(_check2.default, null),
    unchecked: _react2.default.createElement(_x2.default, null)
  }
};

Toggle.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  id: _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string,
  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    checked: _propTypes2.default.node,
    unchecked: _propTypes2.default.node
  })])
};

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '14', height: '11', viewBox: '0 0 14 11' },
    _react2.default.createElement(
      'title',
      null,
      'switch-check'
    ),
    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '10', height: '10', viewBox: '0 0 10 10' },
    _react2.default.createElement(
      'title',
      null,
      'switch-x'
    ),
    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pointerCoord = pointerCoord;
// Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts

function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    var pageX = event.pageX;
    if (pageX !== undefined) {
      return { x: pageX, y: event.pageY };
    }
  }
  return { x: 0, y: 0 };
}

/***/ }),

/***/ 909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SettingToggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);








var SettingToggle = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SettingToggle, _React$PureComponent);

  function SettingToggle() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SettingToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.onChange = function (_ref) {
      var target = _ref.target;

      _this.props.onChange(_this.props.settingKey, target.checked);
    }, _this.onKeyDown = function (e) {
      if (e.key === ' ') {
        _this.props.onChange(_this.props.settingKey, !e.target.checked);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  SettingToggle.prototype.render = function render() {
    var _props = this.props,
        prefix = _props.prefix,
        settings = _props.settings,
        settingKey = _props.settingKey,
        label = _props.label,
        meta = _props.meta;

    var id = ['setting-toggle', prefix].concat(settingKey).filter(Boolean).join('-');

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'setting-toggle'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a, {
      id: id,
      checked: settings.getIn(settingKey),
      onChange: this.onChange,
      onKeyDown: this.onKeyDown
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('label', {
      htmlFor: id,
      className: 'setting-toggle__label'
    }, void 0, label), meta && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      className: 'setting-meta__label'
    }, void 0, meta));
  };

  return SettingToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);



/***/ })

});


// WEBPACK FOOTER //
// features/notifications-08173681c9b0e6c11424.js